<template>
    <div class="base-props-wrapper">
        <div class="prop-content">
            <div class="effect-channel">
                <div class="prop-title">{{ efcUserLabel }}</div>
                <UserSwitchTabs :pickData="effectChannelData" :current="channelData" @userChange="channelSelect" />
            </div>
            <div class="effect-user" v-show="!isContentBase" v-if="isPubg">
                <div class="prop-title">{{ dialogueState }}</div>
                <UserSwitchTabs :pickData="answerBaseProp.dmStatus" :current="dmStatus" @userChange="dmStatusSelect" />
            </div>
            <div class="effect-user" v-show="isContentBase" v-if="isPubg">
                <div class="prop-title">{{ effectType }}：</div>
                <UserSwitchTabs :pickData="answerBaseProp.effectMobileType" :current="users" @userChange="mobileTypeSelect" />
            </div>
            <div class="effect-time">
                <span class="prop-title">{{ efcTimeLabel }}</span>
                <RadioGroup :radios="timeSettings" @change="radioChange" />
                <div class="custom-time" v-show="timeRadios[1].checked">
                    <SingleCalendar
                        @dateSelect="setDateStart"
                        class="time-start"
                        :value="customDate.startTime"
                        :config="answerBaseProp.startTimeConfig"
                    ></SingleCalendar>
                    <span class="span-fgf"></span>
                    <SingleCalendar
                        @dateSelect="setDateEnd"
                        class="time-end"
                        :value="customDate.endTime"
                        :config="answerBaseProp.endTimeConfig"
                    ></SingleCalendar>
                </div>
            </div>
            <div class="cycle-time">
                <span class="prop-title">{{ cycleTimeLabel }}</span>
                <RadioGroup :radios="cycleTimeSettings" @change="cycleRadioChange" />
                <div class="cycle-time-detail" v-show="cycleTimeRadios[1].checked">
                    <UserSwitchTabs :pickData="answerBaseProp.cycleData" :current="users" @userChange="userSelect" />
                </div>
            </div>
            <PropMutliSelect
                class="mulit-selected"
                v-show="cycleTimeRadios[1].checked"
                :title="cycleTitle"
                :initData="users"
                :options="answerBaseProp.cyclePeriod"
                @deleteSelected="deleteSelected"
                @clickSelectIds="clickSelectIds"
            />
        </div>
    </div>
</template>

<script>
import UserSwitchTabs from "@/views/zhiji/bComponents/switchs/UserSwitchTabs";
import RadioGroup from "@/views/zhiji/bComponents/checks/RadioGroup";
import SingleCalendar from "@/views/zhiji/bComponents/calendar/SingleCalendar";
import PropMutliSelect from "./PropMutliSelect";

import { answerBaseProp } from "./answerPropsConfig.js";
import { isPubg } from "@/views/zhiji/js/lib/businessCheck.js";

export default {
    name: "BaseAnsProps",
    components: {
        UserSwitchTabs,
        RadioGroup,
        SingleCalendar,
        PropMutliSelect
    },
    data() {
        return {
            timeRadios: answerBaseProp().effectTimeRadios,
            cycleTimeRadios: answerBaseProp().cycleTimeRadios,
            calendarConfig: {
                position: "right",
                hasRadius: true,
                dateFormat: "YYYY/MM/DD hh:mm"
            },
            effectChannelData: this.setChannelData()
        };
    },
    computed: {
        effectType() {
            return this.$t("zhiji.answer.effectType");
        },
        isContentBase() {
            return this.$store.state.zhiji.gameState.gameId === "80002" ? true : false;
        },
        efcTimeLabel() {
            return this.$t("zhiji.answer.effectiveTime");
        },
        efcUserLabel() {
            return this.$t("zhiji.answer.effectChannel");
        },
        dialogueState() {
            return this.$t("zhiji.answer.dialogueState");
        },
        cycleTimeLabel() {
            return this.$t("zhiji.answer.circulationTime");
        },
        cycleTitle() {
            return this.$t("zhiji.answer.cycleTimePeriod");
        },
        placeholderStart() {
            return this.$t("zhiji.answer.startTime");
        },
        placeholderEnd() {
            return this.$t("zhiji.answer.endTime");
        },
        answerBaseProp() {
            return answerBaseProp();
        },
        dmStatus() {
            return this.getStorePorp("currentAnswer").props.dmStatus;
        },
        users() {
            return this.getStorePorp("currentAnswer").props.effectUser;
        },
        channelData() {
            return this.getStorePorp("currentAnswer").props.effectChannel.channel;
        },
        timeSettings() {
            let props = this.getStorePorp("currentAnswer").props;
            if (props.effectTime.curRadio == "custom") {
                this.setCheckedTime("custom", this.timeRadios);
            } else {
                this.setCheckedTime("all", this.timeRadios);
            }

            return this.timeRadios;
        },
        cycleTimeSettings() {
            let propsId = this.getStorePorp("currentAnswer").props.effectUser;
            let isAllCycleTime = this.computedCycleTime(propsId);

            if (!isAllCycleTime) {
                this.setCheckedTime("custom", this.cycleTimeRadios);
            } else {
                this.setCheckedTime("all", this.cycleTimeRadios);
            }

            return this.cycleTimeRadios;
        },
        customDate() {
            let props = this.getStorePorp("currentAnswer").props;
            let dates = {
                startTime: props.effectTime.startTime ? new Date(props.effectTime.startTime) : "",
                endTime: props.effectTime.endTime ? new Date(props.effectTime.endTime) : ""
            };
            return dates;
        },
        isPubg() {
            return isPubg();
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        setChannelData() {
            const channels = this.$store.state.zhiji.gameState.channels;
            return channels;
            // let gameId = this.$store.state.zhiji.gameState.gameId;
            // if (gameId == "80002") {
            //     //内容助手
            //     return answerBaseProp().contentEffectChannel;
            // } else if (gameId == "80001") {
            //     // 安全助手
            //     return answerBaseProp().effectChannel;
            // } else if (gameId == "88888") {
            //     //基础服务
            //     return answerBaseProp().basicServices;
            // }
        },
        mobileTypeSelect(data) {
            this.updateStoreProp(data);
        },
        dmStatusSelect(data) {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateProp",
                dmStatus: data
            });
        },
        userSelect(user) {
            this.updateStoreProp(user);
        },
        channelSelect(data) {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateProp",
                effectChannel: {
                    channel: data
                }
            });
        },
        clickSelectIds(data) {
            this.updateStoreProp(data);
        },
        deleteSelected(data) {
            this.updateStoreProp(data);
        },
        computedCycleTime(propsId) {
            if (propsId.length < this.answerBaseProp.cycleTimesId.length) {
                return false;
            }
            let propsIdStr = propsId.toString();
            for (let i = 0; i < this.answerBaseProp.cycleTimesId.length; i++) {
                if (propsIdStr.indexOf(this.answerBaseProp.cycleTimesId[i]) < 0) {
                    return false;
                }
            }

            return true;
        },
        setCheckedTime(timeType, radiosData) {
            let all = radiosData[0];
            let custom = radiosData[1];

            all.checked = false;
            custom.checked = false;

            timeType == "custom"
                ? radiosData.splice(1, 1, Object.assign({}, custom, { checked: true }))
                : radiosData.splice(0, 1, Object.assign({}, all, { checked: true }));
        },
        radioChange(timeType) {
            let custom = this.timeRadios[1];

            let currentTime = {
                startTime: custom.startTime,
                endTime: custom.endTime,
                curRadio: timeType
            };

            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateProp",
                effectTime: currentTime
            });
        },
        cycleRadioChange(cycleType) {
            let all = this.cycleTimeRadios[0];
            let custom = this.cycleTimeRadios[1];

            if (cycleType == "custom") {
                all.checked = false;
                custom.checked = true;
                this.updateCycleTimeData(cycleType);
            } else {
                all.checked = true;
                custom.checked = false;
                this.updateCycleTimeData(cycleType);
            }
        },
        updateCycleTimeData(type) {
            let currentProp = this.getStorePorp("currentAnswer").props.effectUser;
            let propsIdStr = currentProp.toString();
            if (type == "custom") {
                for (let i = 0; i < this.answerBaseProp.cycleTimesId.length; i++) {
                    if (propsIdStr.indexOf(this.answerBaseProp.cycleTimesId[i]) > 0) {
                        propsIdStr = propsIdStr.replace(this.answerBaseProp.cycleTimesId[i], "");
                    }
                }
                this.updateStoreProp(propsIdStr.split(",").filter(Boolean));
            } else {
                for (let i = 0; i < this.answerBaseProp.cycleTimesId.length; i++) {
                    if (propsIdStr.indexOf(this.answerBaseProp.cycleTimesId[i]) < 0) {
                        propsIdStr += "," + this.answerBaseProp.cycleTimesId[i];
                    }
                }
                this.updateStoreProp(propsIdStr.split(","));
            }
        },
        updateStoreProp(data) {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateProp",
                effectUser: data
            });
        },
        setDateStart(date) {
            let custom = this.timeRadios[1];
            custom.startTime = date ? this.zhiji.dateFormat(date) : "";

            this.commitTime();
        },
        setDateEnd(date) {
            let custom = this.timeRadios[1];
            custom.endTime = date ? this.zhiji.dateFormat(date) : "";

            this.commitTime();
        },
        commitTime() {
            let custom = this.timeRadios[1];
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateProp",
                effectTime: {
                    startTime: custom.startTime,
                    endTime: custom.endTime,
                    curRadio: "custom"
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.prop-content {
    padding-top: 12px;

    .span-fgf {
        display: inline-block;
        width: 10px;
        height: 2px;
        margin: 0 3px;
        background: #dee9f2;
        vertical-align: middle;
    }

    .cycle-time-detail,
    .custom-time {
        padding: 8px 0;
    }
}

.effect-user,
.effect-channel,
.effect-time {
    margin-bottom: 4px;
    padding: 0 0 0 16px;
}

.cycle-time {
    padding: 0 0 0 16px;
}

.mulit-selected {
    border-top: 1px solid #d8e4f0;
}

.custom-time {
    display: inline-flex;
    align-items: center;
}

.time-start,
.time-end {
    width: 162px !important;
    height: 33px !important;
    display: inline-block;
}

.prop-title {
    width: 105px;
    height: 33px;
    line-height: 33px;
    display: inline-block;
}
</style>
